var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21535 0.382231C8.81176 0.00816894 8.18832 0.00816894 7.78801 0.382231L0.43801 7.20723C0.12301 7.50254 0.0180098 7.95864 0.17551 8.35895C0.33301 8.75926 0.716916 9.02504 1.15004 9.02504H1.67504V14.8C1.67504 15.9583 2.61676 16.9 3.77504 16.9H13.225C14.3833 16.9 15.325 15.9583 15.325 14.8V9.02504H15.85C16.2832 9.02504 16.6704 8.75926 16.8279 8.35895C16.9854 7.95864 16.8804 7.49926 16.5654 7.20723L9.21535 0.382231ZM7.97504 10.6H9.02504C9.89457 10.6 10.6 11.3055 10.6 12.175V15.325H6.40004V12.175C6.40004 11.3055 7.10551 10.6 7.97504 10.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.545f8353eea73233be829e4c409c562b.svg";
export { ForwardRef as ReactComponent };